import { ScoopTextField } from '../../../../../ui/ScoopTextField/ScoopTextField'
import { ScoopSpinner } from '../../../../../ui'
import styles from './CustomIntent.module.scss'

/**
 * Custom intent input step - shown when user selects "Something else"
 * @param {Object} props
 * @param {string} props.value - Current custom intent text
 * @param {Function} props.onChange - Called when text changes
 * @param {string} props.placeholder - Placeholder text for input
 * @param {boolean} props.loading - Loading state
 */
export const CustomIntent = ({ value, onChange, placeholder, loading }) => {
    if (loading) {
        return (
            <div className={styles.loadingContainer}>
                <ScoopSpinner size={40} />
                <span className={styles.loadingText}>Analyzing your request...</span>
            </div>
        )
    }

    return (
        <div className={styles.container}>
            <h3 className={styles.title}>What would you like to analyze?</h3>
            <p className={styles.subtitle}>
                Describe what data you want to extract and we'll configure it for you.
            </p>

            <ScoopTextField
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={
                    placeholder ||
                    'e.g., I want to track marketing campaign performance and see which campaigns generate the most leads...'
                }
                multiline
                rows={4}
                autoFocus
            />
        </div>
    )
}
